import { Container } from '@energiebespaarders/symbols';
import type {
  dummy_dummy_content_ImageBlockRecord,
  dummy_dummy_content_StructuredTextBlockRecord,
} from '~/types/generated/cms/dummy';
import type { getAboutUsPageContent_aboutUsModel } from '~/types/generated/cms/getAboutUsPageContent';
import BlockContainer from '../DatoCms/BlockContainer';
import DatoPage from '../DatoCms/DatoPage';
import TypedStructuredText from '../DatoCms/TypedStructuredText';
import ImageBlock from '../_cmsBlocks/ImageBlockRecord';
import LongReadHero from './LongReadHero';
import type { BlockRendererOverrides } from '../DatoCms/BlockRenderer';

interface Props {
  page: getAboutUsPageContent_aboutUsModel;
}

const Overrides: BlockRendererOverrides = {
  // Overrides that add an extra medium sized wrapper
  StructuredTextBlockRecord: ({ block }) => {
    return (
      <BlockContainer size="md">
        <TypedStructuredText
          data={(block as dummy_dummy_content_StructuredTextBlockRecord).structuredText}
        />
      </BlockContainer>
    );
  },
  ImageBlockRecord: ({ block }) => {
    if (!block) return null;
    return (
      <Container size="md" p={0} m={0}>
        <ImageBlock block={block as dummy_dummy_content_ImageBlockRecord} />
      </Container>
    );
  },
};

const AboutUsPage: React.FC<Props> = ({ page }) => {
  return (
    <DatoPage
      content={page.content}
      metaTags={{ metaTags: page.seo }}
      blockRendererOverrides={Overrides}
    >
      <LongReadHero page={page} />
    </DatoPage>
  );
};

export default AboutUsPage;
